import React, { useState } from 'react'
import { useAuth } from '../../AuthContext'
import { toast } from 'react-toastify'

export const useLinkedInAuth = () => {
    const myContext = useAuth();

    const launchLinkedIn = (accountId = null, onStart, onDone) => {
        const clientId   = "77y9ygszowtw8e";
        const redirectUri = encodeURIComponent("https://schedpilot.com/wp-json/api/v1/callback-analytics");
        const scope       = encodeURIComponent("r_member_postAnalytics r_organization_followers r_organization_social rw_organization_admin r_organization_social_feed w_member_social r_member_profileAnalytics w_organization_social r_basicprofile w_organization_social_feed w_member_social_feed r_1st_connections_size");

        const state = encodeURIComponent(JSON.stringify({
            nonce: Math.random().toString(36).substring(7),
            accountId,
        }));

        const linkedInUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}`;

        const authWindow = window.open(linkedInUrl, 'LinkedInAuth');

        const handleMessage = (event) => {
            if (event.data.type !== "linkedin-authenticated-analytics") return;

            authWindow.close();
            window.removeEventListener("message", handleMessage);

            myContext.setlinkedinconnected(true);
            if (onStart) onStart();

            fetch('https://api.schedpilot.com/wp-json/api/v1/registerAccessTokenLinkedinNew', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ linkedInAccessToken: event.data.token, accountId }),
            })
            .then(res => res.json())
            .then(() => {
                myContext.getAccountsData();
                toast.success(accountId ? 'LinkedIn account reconnected.' : 'LinkedIn account connected!');
            })
            .catch(() => {
                toast.error('LinkedIn connected but failed to save. Please try again.');
            })
            .finally(() => {
                if (onDone) onDone();
            });
        };

        window.addEventListener("message", handleMessage);
    };

    return { launchLinkedIn };
};

export function LinkedInConnectButton() {
    const { launchLinkedIn } = useLinkedInAuth();
    const [loading, setLoading] = useState(false);

    return (
        <button
            className='btn btn-primary'
            disabled={loading}
            onClick={() => launchLinkedIn(null, () => setLoading(true), () => setLoading(false))}
        >
            {loading ? 'Connecting…' : 'Connect LinkedIn'}
        </button>
    );
}

export function LinkedInReconnectButton({ accountId }) {
    const { launchLinkedIn } = useLinkedInAuth();
    const [loading, setLoading] = useState(false);

    return (
        <button
            className='btn btn-sm mr-1 btn-warning'
            disabled={loading}
            onClick={() => launchLinkedIn(accountId, () => setLoading(true), () => setLoading(false))}
        >
            {loading ? 'Reconnecting…' : 'Reconnect Account'}
        </button>
    );
}